import React from 'react';
import { Carousel } from 'antd';
import "./slider.scss"

import Slide1 from '/react4xp/parts/slider/images/slide1.svg';
import Slide2 from '/react4xp/parts/slider/images/slide2.svg';
import Slide3 from '/react4xp/parts/slider/images/slide3.svg';
import Slide4 from '/react4xp/parts/slider/images/slide4.svg';
import { localize } from '/react4xp/mixins/helpers';

const Slider = ({ translations }: { translations: Record<string, string> }) => {
    return (
        <div className="slider__container">
            <Carousel  autoplay={true} autoplaySpeed={5000}>
                <div className="slide-content">
                    <Slide1 />
                    <p>{localize('block-auth-access-to-public-services', translations)}</p>
                </div>
                <div className="slide-content">
                    <Slide2 />
                    <p>{localize('block-auth-informing-citizens', translations)}</p>
                </div>
                <div className="slide-content">
                    <Slide3 />
                    <p>{localize('block-auth-check-partners', translations)}</p>
                </div>
                <div className="slide-content">
                    <Slide4 />
                    <p>{localize('block-auth-information-space', translations)}</p>
                </div>
            </Carousel>
        </div>
    );
};

export default Slider;

